import React, { useEffect, useState } from "react";
import { Button, Group, Text } from "@mantine/core";
import { useTranslation } from "react-i18next";
import { useServerApi } from "../hooks/userServerApi";
import AccountingReportFilters from "./accounting/AccountingReportFilters";
import BalanceSheetView from "./accounting/BalanceSheetView";
import { defaultPeriodEndDate } from "./accounting/financialStatementsUtils";

const ReportBalanceSheet = () => {
  const [api] = useServerApi();
  const { t } = useTranslation();
  const [fiscalPeriodId, setFiscalPeriodId] = useState(null);
  const [bsAsOfDate, setBsAsOfDate] = useState(null);
  const [loading, setLoading] = useState(false);
  const [report, setReport] = useState(null);

  const load = async (overrides = {}) => {
    const effectiveBsAsOf = overrides.bsAsOfDate ?? bsAsOfDate;

    setLoading(true);
    try {
      const query = {};
      if (fiscalPeriodId) query.fiscalPeriodId = fiscalPeriodId;
      if (effectiveBsAsOf) query.endDate = effectiveBsAsOf.toISOString();
      const data = await api.Accounting.getBalanceSheet(query);
      setReport(data);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (!fiscalPeriodId) return;

    const initPeriod = async () => {
      setLoading(true);
      try {
        const period = await api.getById({
          apiEntity: "fiscalPeriod",
          id: fiscalPeriodId,
        });
        const periodEnd = defaultPeriodEndDate(period?.endDate);
        setBsAsOfDate(periodEnd);

        const query = { fiscalPeriodId };
        if (periodEnd) query.endDate = periodEnd.toISOString();
        const data = await api.Accounting.getBalanceSheet(query);
        setReport(data);
      } finally {
        setLoading(false);
      }
    };

    initPeriod();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [fiscalPeriodId]);

  return (
    <div>
      <Text size="xs" color="dimmed" mb="xs">
        {t("Statement of Financial Position as at the selected date.")}
      </Text>
      <AccountingReportFilters
        fiscalPeriodId={fiscalPeriodId}
        onFiscalPeriodChange={setFiscalPeriodId}
        showBsAsOfDate
        bsAsOfDate={bsAsOfDate}
        onBsAsOfDateChange={setBsAsOfDate}
      />
      <Group mb="sm">
        <Button size="xs" onClick={() => load()} loading={loading}>
          {t("Run Report")}
        </Button>
      </Group>
      <BalanceSheetView report={report} loading={loading} />
    </div>
  );
};

export default ReportBalanceSheet;
